// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3WRdv","header":"PatientBlock_header__1ZISM","label":"PatientBlock_label__-qtAK","option":"PatientBlock_option__2MnTw"};